import { styles } from "./styles";

// Shared card chrome for the charts. Suppressed/empty sections are not rendered
// at all (the parent hides them) — we never show "not enough data yet" cards.
export function ChartCard({ title, hint, children }) {
  return (
    <section style={styles.card}>
      <h3 style={styles.cardTitle}>{title}</h3>
      {hint ? <p style={styles.cardHint}>{hint}</p> : null}
      {children}
    </section>
  );
}
